import { Heading, Subheading } from '@/src/tailwindui/heading';
import { Button } from '@headlessui/react';
import useShareStats from './hooks/useShareStats';
import { CSVLink } from 'react-csv';
import SmallLoader from '@/src/Common/components/SmallLoader';
import { cn } from '@/src/lib/utils';

export default function ShareStats({ activationId }: { activationId: number }) {
    const { totalShares, emailShares, smsShares, shares, isLoading } =
        useShareStats(activationId);
    return (
        <div className="relative mx-auto max-w-4xl w-full h-full overflow">
            <div className="flex flex-col gap-4 py-4">
                <div className="flex flex-wrap items-end justify-between gap-4 transition-all duration-300 px-4 ">
                    <Heading className="text-2xl">Share Stats</Heading>
                </div>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-4 transition-all duration-300 px-4 ">
                <div className="flex flex-row justify-between w-full">
                    <div className="flex flex-col gap-2 pt-4 w-full">
                        <Subheading>Total Shares</Subheading>
                        <div className="flex items-center gap-2 w-full">
                            <p className="text-4xl monospace-font text-[#262C2C] dark:text-white">
                                {totalShares}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-2 pr-4">
                        <Subheading>Email</Subheading>
                        <div className="flex items-center gap-2 w-full">
                            <p className="text-2xl monospace-font text-[#262C2C] dark:text-white">
                                {emailShares}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Subheading>SMS</Subheading>
                        <div className="flex items-center gap-2 w-full">
                            <p className="text-2xl monospace-font text-[#262C2C] dark:text-white">
                                {smsShares}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="absolute bottom-6 right-6">
                {totalShares > 0 && (
                    <CSVLink
                        data={shares}
                        filename={`PhotoEngineersShares.csv`}
                        target="_blank"
                    >
                        <Button className="light-button flex text-white px-4 py-2 rounded-md">
                            Download CSV&nbsp;&nbsp;&darr;
                        </Button>
                    </CSVLink>
                )}
            </div>
            <div
                className={cn(
                    'flex justify-center items-center h-full w-full absolute top-0 left-0 bg-white dark:bg-black transition-all duration-300',
                    isLoading ? 'opacity-100' : 'opacity-0 invisible',
                )}
            >
                <SmallLoader />
            </div>
            <div className="my-10 mt-6" />
        </div>
    );
}
